export default "__VITE_ASSET__DzasH_Kq__"